import React, { useContext } from 'react'
import { ProfilesStyles } from './Style'
import { ProfilesContext } from './ProfilesContext'
import { Chip } from 'components/Form'
import { useSelector } from 'react-redux'

const Profiles = ({ data: categoryProfiles }) => {
    // הגנה בסיסית: אם אין דאטה, נשתמש באובייקט ריק כדי למנוע קריסות
    const data = categoryProfiles?.data || {}

    const { brokenDisplay } = useSelector(state => state.general)
    const { visibleRatings, showDetails } = useContext(ProfilesContext)

    return (
        <ProfilesStyles>
            {/* מעבר על קבוצות היכולת */}
            {Object.entries(data).map(([abilityKey, abilityGroup]) => (
                <div key={abilityKey} className='ability-group'>

                    <div className='ability-label'>
                        {/* השתמשתי בשם שהגדרנו בשרת, או בלייבל שלך */}
                        {abilityGroup.ability_label || abilityGroup.ability_name}
                    </div>

                    <div className='profile-content-cards overflow'>
                        <div className='categories'>

                            {/* מעבר על הקטגוריות בתוך קבוצת היכולת */}
                            {Object.entries(abilityGroup.categories || {}).map(([categoryId, categoryData]) => (
                                <div key={categoryId} className='category-item'>
                                    <div>{categoryData.category_label}</div>

                                    <div className='profile-cards'>

                                        {/* מעבר על הדירוגים בתוך הקטגוריה */}
                                        {Object.entries(categoryData.ratings || {}).map(([ratingIndex, ratingData]) => {

                                            // אם הדירוג לא מופעל בפילטר, לא נרנדר אותו בכלל
                                            if (!visibleRatings[ratingIndex]) return null;

                                            return (
                                                ratingData.students?.length < 1 ||
                                                <div key={ratingIndex} className='profile-content-cards'>

                                                    {/* מעבר על התלמידים */}
                                                    {ratingData.students?.map((student) => (
                                                        <div
                                                            key={student.id}
                                                            className={`profile-content-card-item ${brokenDisplay ? 'blurred2' : ''}`}
                                                        >
                                                            <Chip color={`rating${ratingIndex}`}>
                                                                {student.name}
                                                                {showDetails && `, ${student.school_class}`}
                                                            </Chip>
                                                        </div>
                                                    ))}
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            ))}
        </ProfilesStyles>
    )
}

export default Profiles